import React, { useRef, useEffect } from 'react';
import './Helmet.scss';
import videomov from '../../../../assets/apollo/helmet/apollo_helmet_mobile.mov';
import video from '../../../../assets/apollo/helmet/apollo_helmet_mobile.webm';
import poster from '../../../../assets/apollo/helmet/apollo_helmet_mobile_poster.png';
import videomovD from '../../../../assets/apollo/helmet/apollo_helmet_desktop.mov';
import videoD from '../../../../assets/apollo/helmet/apollo_helmet_desktop.webm';
import posterD from '../../../../assets/apollo/helmet/apollo_helmet_desktop_poster.png';

function ApolloHelmet({ screenWidth }) {
  // const apolloHelmetCanvas = useRef();
  const apolloHelmetSection = useRef();
  const apolloHelmetAnimation = useRef();
  // const images = useRef([]);
  // const ratio = useRef();
  const videoMRef = useRef();
  const videoDRef = useRef();
  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              screenWidth > 480 ? videoDRef.current.play() : videoMRef.current.play();
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(apolloHelmetAnimation.current);
  }, [screenWidth]);

  // useEffect(() => {
  //   ratio.current = screenWidth > 480 ? 1.28 : 1.777;
  //   images.current = [];
  //   // set canvas properties
  //   const canvas = apolloHelmetCanvas.current.getContext('2d');
  //   // Set the size of the canvas
  //   apolloHelmetCanvas.current.width =
  //     screenWidth > 480 ? Math.min(window.innerWidth * 0.3, 492) : window.innerWidth;
  //   apolloHelmetCanvas.current.height = apolloHelmetCanvas.current.width * ratio.current;

  //   // Count the frames and set the path to the images
  //   const frameCount = 41;
  //   const currentFrame = (index, screenSize) =>
  //     `https://morgan-stanley-creating-space-cdn.s3.amazonaws.com/apollo/helmet/${screenSize}/A7L_HELMET${(
  //       index + 1
  //     )
  //       .toString()
  //       .padStart(2, '0')}.png`;
  //   // Set start frame

  //   const target = {
  //     frame: 0
  //   };

  //   // Go through frames from start to finish
  //   const anim = gsap.timeline({
  //     scrollTrigger: {
  //       trigger: apolloHelmetAnimation.current,
  //       start: 'top 30%',
  //       end: 'bottom bottom',
  //       scrub: 1
  //     }
  //   });

  //   if (screenWidth < 481) {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'mobile');
  //       images.current.push(img);
  //     }
  //   } else {
  //     for (let i = 0; i < frameCount; i++) {
  //       const img = new Image();
  //       img.src = currentFrame(i, 'desktop');
  //       images.current.push(img);
  //     }
  //   }

  //   anim.add('start').to(
  //     target,
  //     {
  //       frame: frameCount - 1,
  //       snap: 'frame',
  //       duration: 5,
  //       ease: 'linear',
  //       onUpdate: () => {
  //         render();
  //       }
  //     },
  //     'start'
  //   );

  //   images.current[0].onload = render;

  //   function render() {
  //     canvas.clearRect(0, 0, apolloHelmetCanvas.current.width, apolloHelmetCanvas.current.height);
  //     canvas.drawImage(
  //       images.current[target.frame],
  //       0,
  //       0,
  //       apolloHelmetCanvas.current.width,
  //       apolloHelmetCanvas.current.height
  //     );
  //   }
  // }, [screenWidth, images]);

  return (
    <section className="helmet helmet-apollo" ref={apolloHelmetSection}>
      <div className="helmet__upper helmet__upper-apollo">
        <h3 className="helmet__title helmet__title-apollo">
          The A7L spacesuits were custom-tailored and hand-sewn to fit individual astronauts.
        </h3>
      </div>
      <div className="helmet__lower helmet__lower-apollo">
        <div className="helmet__animation helmet__animation-apollo" ref={apolloHelmetAnimation}>
          {screenWidth > 480 ? (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoDRef}
              className="video"
              poster={posterD}
            >
              <source src={videomovD} type="video/quicktime" />
              <source src={videoD} type="video/webm" />
            </video>
          ) : (
            <video
              muted
              playsInline
              preload="auto"
              ref={videoMRef}
              className="video"
              poster={poster}
            >
              <source src={videomov} type="video/quicktime" />
              <source src={video} type="video/webm" />
            </video>
          )}
          {/* <canvas className="helmet__animation__canvas" ref={apolloHelmetCanvas} /> */}
        </div>
        <div className="helmet__lower__text helmet__lower__text-apollo">
          <h3 className="helmet__lower__text__title helmet__lower__text__title-apollo">
            UV Protective Sun Visor
          </h3>
          <p className="helmet__lower__text__copy helmet__lower__text__copy-apollo">
            A thin gold layer in the EVVA sun visor absorbed dangerous UV radiation and attenuated
            light, while giving the helmet its signature color.
          </p>
          <h3 className="helmet__lower__text__title helmet__lower__text__title-apollo">
            Audio Assembly
          </h3>
          <p className="helmet__lower__text__copy helmet__lower__text__copy-apollo">
            Apollo 11 astronauts’ helmets included an audio-enabled skullcap, a pressurized bubble,
            and an Extravehicular Visor Assembly, or EVVA.
          </p>
        </div>
      </div>
    </section>
  );
}

export default ApolloHelmet;
